import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from '@ep-om/core/directives/directives.module';
import { UserSelectComponent } from '@ep-om/jira-control/user-select/user-select.component';
import { UsersSelectionComponent } from '@ep-om/jira-control/users-selection/users-selection.component';
import { UserComponent } from '@ep-om/project/components/user/user.component';
import { TranslateModule } from '@ngx-translate/core';
import { ColorPickerModule } from 'ngx-color-picker';
import { AvatarComponent } from './avatar/avatar.component';
import { UploadAvatarComponent } from './avatar/upload-avatar/upload-avatar.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { ButtonComponent } from './button/button.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { ColorPickerComponent } from './color-picker/color-picker.component';
import { DateInputComponent } from './date-input/date-input.component';
import { DummySkeletonComponent } from './dummy-skeleton/dummy-skeleton.component';
import { InputComponent } from './input/input.component';
import { OmButtonComponent } from './om-button/om-button.component';
import { OmCheckRenderComponent } from './om-check-render/om-check-render.component';
import { OmCheckboxComponent } from './om-checkbox/om-checkbox.component';
import { OmDateInputComponent } from './om-date-input/om-date-input.component';
import { OmDebugComponent } from './om-debug/om-debug.component';
import { OmErrorComponent } from './om-error/om-error.component';
import { OmHintComponent } from './om-hint/om-hint.component';
import { OmInputNumberComponent } from './om-input-number/om-input-number.component';
import { OmInputComponent } from './om-input/om-input.component';
import { OmLabelComponent } from './om-label/om-label.component';
import { OmMentionComponent } from './om-mention/om-mention.component';
import { OmSelectIconComponent } from './om-select-icon/om-select-icon.component';
import { OmSelectComponent } from './om-select/om-select.component';
import { OmSimpleTableComponent } from './om-simple-table/om-simple-table.component';
import { OmSwitchComponent } from './om-switch/om-switch.component';
import { OmTextareaComponent } from './om-textarea/om-textarea.component';
import { OmTimeInputComponent } from './om-time-input/om-time-input.component';
import { SelectAutocomplete } from './select-autocomplete/select-autocomplete.component';
import { SelectComponent } from './select/select.component';
import { SvgDefinitionsComponent } from './svg-definitions/svg-definitions.component';
import { SvgIconComponent } from './svg-icon/svg-icon.component';
import { TagListComponent } from './tag/tag-list/tag-list.component';
import { TagComponent } from './tag/tag.component';

import { CommonModule } from '@angular/common';
import { NgZorroModule } from '@ep-om/shared/ng-zorro/ng-zorro.module';

import { OmDayPickerComponent } from './om-day-picker/om-day-picker.component';
import { OmTimeRangeComponent } from './om-time-range/om-time-range.component';
import { OmDateRangeComponent } from './om-date-range/om-date-range.component';
import { OmFileUploadComponent } from './om-file-upload/om-file-upload.component';

const JiraControlComponents = [
  SvgDefinitionsComponent,
  SvgIconComponent,
  BreadcrumbsComponent,
  ButtonComponent,
  OmButtonComponent,
  InputComponent,
  CheckboxComponent,
  AvatarComponent,
  UploadAvatarComponent,
  DateInputComponent,
  SelectComponent,
  OmTextareaComponent,
  TagComponent,
  TagListComponent,
  DummySkeletonComponent,
  OmButtonComponent,
  OmLabelComponent,
  OmHintComponent,
  OmErrorComponent,
  OmInputComponent,
  OmInputNumberComponent,
  OmSelectComponent,
  OmDateInputComponent,
  OmTimeInputComponent,
  OmMentionComponent,
  OmCheckRenderComponent,
  OmSimpleTableComponent,
  SelectAutocomplete,
  OmSwitchComponent,
  ColorPickerComponent,
  OmSelectIconComponent,
  OmDebugComponent,
  OmCheckboxComponent,
  UserSelectComponent,
  UsersSelectionComponent,
  UserComponent,
  OmTimeRangeComponent,
  OmDateRangeComponent,
  OmDayPickerComponent,
  OmFileUploadComponent
];
@NgModule({
  declarations: JiraControlComponents,
  exports: JiraControlComponents,
  imports: [
    TranslateModule.forChild({ extend: true, isolate: false }),
    CommonModule,
    DirectivesModule,
    NgZorroModule,
    FormsModule,
    ReactiveFormsModule,
    ColorPickerModule
  ]
})
export class JiraControlModule {}
